import { render, staticRenderFns } from "./batch.vue?vue&type=template&id=903844d4&scoped=true&"
import script from "./batch.vue?vue&type=script&lang=js&"
export * from "./batch.vue?vue&type=script&lang=js&"
import style0 from "./batch.vue?vue&type=style&index=0&id=903844d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903844d4",
  null
  
)

export default component.exports